<script setup>
import { ref, onMounted } from 'vue';
import { $api } from '@/services';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import Loading from '@/components/common/Loading.vue';

const store = useStore();
const route = useRoute();
const alertShow = ref(true);
const staffData = ref(null);
const loading = ref(false);
const fetchData = async () => {
	try {
		loading.value = true;
		const res = await $api.staff.staffProfile(route.params.id);
		staffData.value = res.data.data;
	} catch (err) {
		await store.dispatch('setAlertMessage', {
			message:
				err?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	} finally {
		loading.value = false;
	}
};

const formatDate = (dateString, reverse) => {
	const date = new Date(dateString);
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	let formattedDate;
	if (reverse) formattedDate = `${year}-${month}-${day}`;
	else formattedDate = `${day}/${month}/${year}`;
	return formattedDate;
};

onMounted(() => {
	fetchData();
});
</script>
<template>
	<div class="px-12 md-down:px-4 pb-12">
		<div
			class="text-neutral-500 font-bold whitespace-nowrap flex flex-nowrap items-center text-4xl gap-4 pt-10 pb-10"
		>
			<svg
				class="cursor-pointer"
				width="28"
				height="28"
				viewBox="0 0 28 28"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				@click="
					$router.push(
						`/record/employee/${route.params.id}?tab=record_employee_file`
					)
				"
			>
				<path
					d="M17.5 7L10.5 14L17.5 21"
					stroke="#94A3B8"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
			<div>Xem trước hồ sơ gửi Phụ huynh</div>
		</div>
		<div
			v-if="alertShow"
			class="bg-yellow-50 border-l-4 border-yellow-600 p-4 rounded-md mb-4"
		>
			<div class="relative">
				<div class="flex items-center gap-4 pr-8">
					<div>
						<img
							src="@/assets/images/logo/logo.svg"
							alt="luca-logo"
							height="24"
							width="35"
						/>
					</div>
					<div class="pt-1 text-neutral-600 text-sm">
						Các mục chưa có thông tin sẽ KHÔNG được hiển thị cho Phụ
						Huynh
					</div>
				</div>
				<div
					class="top-1 right-2 absolute cursor-pointer"
					@click="alertShow = false"
				>
					<svg
						width="12"
						height="12"
						viewBox="0 0 12 12"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6 4.58579L10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L7.41421 6L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071L6 7.41421L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L4.58579 6L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
							fill="#E5A42B"
						/>
					</svg>
				</div>
			</div>
		</div>
		<div v-if="loading">
			<Loading />
		</div>
		<div v-else class="bg-white rounded-2xl shadow-sm w-full p-8">
			<div class="flex gap-10">
				<div class="block-1 w-2/3">
					<div class="text-neutral-600 font-semibold text-5xl">
						{{
							staffData?.public_information?.staff_information
								?.name
						}}
					</div>
					<div class="text-neutral-600 font-semibold text-lg mt-3">
						{{
							staffData?.public_information?.professional_qualifications?.official_job_title.join(
								', '
							)
						}}
					</div>
					<div
						class="text-neutral-800 mt-3"
						v-if="
							staffData?.public_information
								?.orientation_and_work_style?.personal_slogan
						"
					>
						"{{
							staffData?.public_information
								?.orientation_and_work_style?.personal_slogan
						}}"
					</div>
					<div class="flex flex-wrap mt-6">
						<div
							class="w-1/2 flex items-center gap-2"
							v-if="
								staffData?.public_information?.staff_information
									?.date_of_birth
							"
						>
							<img
								src="@/assets/images/icons/big-birthday.png"
								alt=""
								class="w-12 h-12"
							/>
							<div class="text-neutral-800">
								{{
									formatDate(
										staffData?.public_information
											?.staff_information?.date_of_birth
									)
								}}
							</div>
						</div>
						<div
							class="w-1/2 flex items-center gap-2"
							v-if="
								staffData?.public_information?.staff_information
									?.gender
							"
						>
							<img
								src="@/assets/images/icons/big-gender.png"
								alt=""
								class="w-12 h-12"
							/>
							<div class="text-neutral-800">
								{{
									staffData.public_information
										.staff_information.gender === 'male'
										? 'Nam'
										: 'Nữ'
								}}
							</div>
						</div>
						<div
							class="w-1/2 flex items-center gap-2 mt-3"
							v-if="
								staffData?.public_information?.staff_information
									?.phone_number
							"
						>
							<img
								src="@/assets/images/icons/big-phone.png"
								alt=""
								class="w-12 h-12"
							/>
							<div class="text-neutral-800">
								{{
									staffData.public_information
										.staff_information.phone_number
								}}
							</div>
						</div>
						<div
							class="w-1/2 flex items-center gap-2 mt-3"
							v-if="
								staffData?.public_information?.staff_information
									?.email
							"
						>
							<img
								class="w-12 h-12"
								src="@/assets/images/icons/big-email.png"
								alt=""
							/>
							<div class="text-neutral-800">
								{{
									staffData.public_information
										.staff_information.email
								}}
							</div>
						</div>
					</div>
					<div class="mt-6">
						<div
							v-if="
								staffData?.public_information
									?.orientation_and_work_style
									?.intervention_philosophy
							"
						>
							<div
								class="text-neutral-400 font-semibold text-xs uppercase tracking-wider"
							>
								Quan điểm cá nhân về việc can thiệp
							</div>
							<div class="text-neutral-800 mt-1">
								{{
									staffData?.public_information
										?.orientation_and_work_style
										?.intervention_philosophy
								}}
							</div>
						</div>
						<div
							v-if="
								staffData?.public_information
									?.orientation_and_work_style
									?.parent_commitment_principles
							"
						>
							<div
								class="text-neutral-400 font-semibold text-xs mt-6 uppercase tracking-wider"
							>
								Cam kết, nguyên tắc đồng hành cùng phụ huynh
							</div>
							<div class="text-neutral-800 mt-1">
								{{
									staffData?.public_information
										?.orientation_and_work_style
										?.parent_commitment_principles
								}}
							</div>
						</div>
						<div
							v-if="
								staffData?.public_information
									?.orientation_and_work_style
									?.collaboration_skills
							"
						>
							<div
								class="text-neutral-400 font-semibold text-xs mt-6 uppercase tracking-wider"
							>
								Khả năng phối hợp với đồng nghiệp
							</div>
							<div class="text-neutral-800 mt-1">
								{{
									staffData?.public_information
										?.orientation_and_work_style
										?.collaboration_skills
								}}
							</div>
						</div>
					</div>
					<div class="mt-6">
						<div
							class="text-neutral-600 font-semibold text-3xl mb-2"
						>
							CV / Sơ yếu lý lịch
						</div>
						<div
							v-if="
								staffData?.public_information?.attachments
									?.resume_url
							"
						>
							<div
								v-if="
									staffData?.public_information?.attachments
										?.resume_type !== 'application/pdf'
								"
								class="rounded-lg relative"
							>
								<img
									:src="
										staffData?.public_information
											?.attachments?.resume_url
									"
									alt=""
									class="rounded-lg object-fill h-full w-full"
								/>
							</div>
							<div
								v-if="
									staffData?.public_information?.attachments
										?.resume_type === 'application/pdf'
								"
								class="rounded-lg relative"
							>
								<div
									class="text-neutral-400 flex items-center gap-2"
								>
									<svg
										width="24"
										height="32"
										viewBox="0 0 24 32"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M0 4C0 1.79086 1.79086 0 4 0H14.5858C15.1162 0 15.6249 0.210714 16 0.585786L23.4142 8C23.7893 8.37507 24 8.88378 24 9.41421V28C24 30.2091 22.2091 32 20 32H4C1.79086 32 0 30.2091 0 28V4ZM15 7V3L21 9H17C15.8954 9 15 8.10457 15 7ZM17.7071 15.7071C18.0976 15.3166 18.0976 14.6834 17.7071 14.2929C17.3166 13.9024 16.6834 13.9024 16.2929 14.2929L11 19.5858L8.70711 17.2929C8.31658 16.9024 7.68342 16.9024 7.29289 17.2929C6.90237 17.6834 6.90237 18.3166 7.29289 18.7071L10.2929 21.7071C10.4804 21.8946 10.7348 22 11 22C11.2652 22 11.5196 21.8946 11.7071 21.7071L17.7071 15.7071Z"
											fill="#E5A42B"
										/>
									</svg>
									<a
										:href="
											staffData?.public_information
												?.attachments?.resume_url
										"
										target="_blank"
										class="text-neutral-600 font-semibold cursor-pointer hover:underline"
									>
										{{
											staffData?.public_information
												?.attachments?.resume_file_name
										}}</a
									>
								</div>
							</div>
						</div>
					</div>
					<div class="mt-6">
						<div class="text-neutral-600 font-semibold text-3xl">
							Học vấn
						</div>
						<div
							v-if="
								staffData?.public_information?.professional_qualifications?.major?.filter(
									(major) => major && major.length > 0
								)?.length > 0
							"
						>
							<div
								class="text-neutral-400 font-semibold text-xs uppercase tracking-wider mt-3"
							>
								Chuyên ngành đào tạo
							</div>
							<div
								class="text-neutral-800 mt-1 pl-4"
								v-for="major in staffData?.public_information
									?.professional_qualifications?.major"
								:key="major"
							>
								<li>{{ major }}</li>
							</div>
						</div>
						<div
							v-if="
								staffData?.public_information
									?.professional_qualifications
									?.highest_education_level
							"
						>
							<div
								class="text-neutral-400 font-semibold text-xs uppercase tracking-wider mt-6"
							>
								Trình độ học vấn cao nhất
							</div>
							<div class="text-neutral-800 mt-1">
								{{
									staffData?.public_information
										?.professional_qualifications
										?.highest_education_level
								}}
							</div>
						</div>
						<div
							v-if="
								staffData?.public_information
									?.professional_qualifications?.academic_rank
							"
						>
							<div
								class="text-neutral-400 font-semibold text-xs uppercase tracking-wider mt-6"
							>
								Học hàm
							</div>
							<div class="text-neutral-800 mt-1">
								{{
									staffData?.public_information
										?.professional_qualifications
										?.academic_rank
								}}
							</div>
						</div>
						<div
							v-if="
								staffData?.public_information
									?.professional_qualifications
									?.academic_degree
							"
						>
							<div
								class="text-neutral-400 font-semibold text-xs uppercase tracking-wider mt-6"
							>
								Học vị
							</div>
							<div class="text-neutral-800 mt-1">
								{{
									staffData?.public_information
										?.professional_qualifications
										?.academic_degree
								}}
							</div>
						</div>
					</div>
					<div class="mt-6">
						<div class="text-neutral-600 font-semibold text-3xl">
							Kinh nghiệm
						</div>
						<div
							class="text-neutral-400 font-semibold text-xs uppercase tracking-wider mt-3"
						>
							Kinh nghiệm làm việc
						</div>
						<div class="text-neutral-800 mt-1">
							{{
								staffData?.public_information
									?.professional_qualifications
									?.years_of_experience
							}}
						</div>
						<div
							v-if="
								staffData?.public_information?.professional_qualifications?.target_group_experience?.filter(
									(tge) => tge && tge.length > 0
								)?.length > 0
							"
						>
							<div
								class="text-neutral-400 font-semibold text-xs uppercase tracking-wider mt-6"
							>
								Đối tượng đã làm việc
							</div>
							<div
								class="text-neutral-800 mt-1 pl-4"
								v-for="tge in staffData?.public_information
									?.professional_qualifications
									?.target_group_experience"
								:key="tge"
							>
								<li>{{ tge }}</li>
							</div>
						</div>
						<div
							v-if="
								staffData?.public_information?.professional_qualifications?.key_achievements?.filter(
									(ka) => ka && ka.length > 0
								)?.length > 0
							"
						>
							<div
								class="text-neutral-400 font-semibold text-xs uppercase tracking-wider mt-6"
							>
								Thế mạnh, thành công nổi bật
							</div>
							<div
								class="text-neutral-800 mt-1 pl-4"
								v-for="ka in staffData?.public_information
									?.professional_qualifications
									?.key_achievements"
								:key="ka"
							>
								<li>{{ ka }}</li>
							</div>
						</div>
						<div
							v-if="
								staffData?.public_information?.professional_qualifications?.development_activities?.filter(
									(da) => da && da.length > 0
								)?.length > 0
							"
						>
							<div
								class="text-neutral-400 font-semibold text-xs uppercase tracking-wider mt-6"
							>
								Khóa học, hoạt động phát triển bản thân
							</div>
							<div
								class="text-neutral-800 mt-1 pl-4"
								v-for="da in staffData?.public_information
									?.professional_qualifications
									?.development_activities"
								:key="da"
							>
								<li>{{ da }}</li>
							</div>
						</div>
					</div>
					<div
						v-if="
							staffData?.public_information?.professional_qualifications?.tech_skills?.filter(
								(ts) => ts && ts.length > 0
							)?.length > 0
						"
					>
						<div class="mt-6">
							<div
								class="text-neutral-600 font-semibold text-3xl"
							>
								Sử dụng công nghệ, phần mềm
							</div>
							<div
								class="text-neutral-800 mt-1 pl-4"
								v-for="ts in staffData?.public_information
									?.professional_qualifications?.tech_skills"
								:key="ts"
							>
								<li>{{ ts }}</li>
							</div>
						</div>
					</div>
				</div>
				<div class="block-2 w-1/3">
					<div class="avatar flex justify-center">
						<img
							class="shadow-sm inline-block h-auto w-full"
							:src="
								staffData?.public_information?.attachments
									?.avatar_url ||
								staffData?.staff?.profile_photo?.w200
							"
							alt=""
							v-if="
								staffData?.public_information?.attachments
									?.avatar_url ||
								staffData?.staff?.profile_photo?.w200
							"
						/>
						<span
							v-else
							class="shadow-sm inline-flex items-center justify-center h-20 w-20 rounded-full text-white text-4xl"
							:style="{
								background:
									staffData?.staff?.profile_photo?.default
										?.color,
							}"
						>
							<span class="font-medium leading-none text-white">{{
								staffData?.staff?.profile_photo?.default
									?.initial
							}}</span>
						</span>
					</div>

					<div
						class="mt-6"
						v-for="degree in staffData?.public_information
							?.certificates_and_awards?.degrees"
						:key="degree"
					>
						<div class="text-neutral-600 font-semibold text-lg">
							{{ degree.degree_name }}
						</div>
						<div class="text-neutral-800 text-sm mt-1">
							{{ degree.institution_name }}
						</div>
						<div class="text-neutral-500 text-sm mt-1">
							{{ degree.degree_major }}
						</div>
						<div v-if="degree?.degree_file_url">
							<div
								v-if="degree?.type !== 'application/pdf'"
								class="rounded-lg relative mt-2"
							>
								<img
									:src="degree?.degree_file_url"
									alt=""
									class="rounded-lg object-fill h-full w-full"
								/>
							</div>
							<div
								v-if="degree?.type === 'application/pdf'"
								class="rounded-lg relative mt-2"
							>
								<div
									class="text-neutral-400 flex items-center gap-2"
								>
									<svg
										width="24"
										height="32"
										viewBox="0 0 24 32"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M0 4C0 1.79086 1.79086 0 4 0H14.5858C15.1162 0 15.6249 0.210714 16 0.585786L23.4142 8C23.7893 8.37507 24 8.88378 24 9.41421V28C24 30.2091 22.2091 32 20 32H4C1.79086 32 0 30.2091 0 28V4ZM15 7V3L21 9H17C15.8954 9 15 8.10457 15 7ZM17.7071 15.7071C18.0976 15.3166 18.0976 14.6834 17.7071 14.2929C17.3166 13.9024 16.6834 13.9024 16.2929 14.2929L11 19.5858L8.70711 17.2929C8.31658 16.9024 7.68342 16.9024 7.29289 17.2929C6.90237 17.6834 6.90237 18.3166 7.29289 18.7071L10.2929 21.7071C10.4804 21.8946 10.7348 22 11 22C11.2652 22 11.5196 21.8946 11.7071 21.7071L17.7071 15.7071Z"
											fill="#E5A42B"
										/>
									</svg>
									<a
										:href="degree?.degree_file_url"
										target="_blank"
										class="text-neutral-600 font-semibold cursor-pointer hover:underline"
									>
										{{ degree.file_name }}</a
									>
								</div>
							</div>
						</div>
					</div>
					<div
						class="mt-6"
						v-for="certificate in staffData?.public_information
							?.certificates_and_awards?.certificates"
						:key="certificate"
					>
						<div class="text-neutral-600 font-semibold text-lg">
							{{ certificate.cert_name }}
						</div>
						<div class="text-neutral-500 text-sm mt-1">
							{{ certificate.cert_description }}
						</div>
						<div v-if="certificate?.cert_file_url">
							<div
								v-if="certificate?.type !== 'application/pdf'"
								class="rounded-lg relative mt-2"
							>
								<img
									:src="certificate?.cert_file_url"
									alt=""
									class="rounded-lg object-fill h-full w-full"
								/>
							</div>
							<div
								v-if="certificate?.type === 'application/pdf'"
								class="rounded-lg relative mt-2"
							>
								<div
									class="text-neutral-400 flex items-center gap-2"
								>
									<svg
										width="24"
										height="32"
										viewBox="0 0 24 32"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M0 4C0 1.79086 1.79086 0 4 0H14.5858C15.1162 0 15.6249 0.210714 16 0.585786L23.4142 8C23.7893 8.37507 24 8.88378 24 9.41421V28C24 30.2091 22.2091 32 20 32H4C1.79086 32 0 30.2091 0 28V4ZM15 7V3L21 9H17C15.8954 9 15 8.10457 15 7ZM17.7071 15.7071C18.0976 15.3166 18.0976 14.6834 17.7071 14.2929C17.3166 13.9024 16.6834 13.9024 16.2929 14.2929L11 19.5858L8.70711 17.2929C8.31658 16.9024 7.68342 16.9024 7.29289 17.2929C6.90237 17.6834 6.90237 18.3166 7.29289 18.7071L10.2929 21.7071C10.4804 21.8946 10.7348 22 11 22C11.2652 22 11.5196 21.8946 11.7071 21.7071L17.7071 15.7071Z"
											fill="#E5A42B"
										/>
									</svg>
									<a
										:href="certificate?.cert_file_url"
										target="_blank"
										class="text-neutral-600 font-semibold cursor-pointer hover:underline"
									>
										{{ certificate.file_name }}</a
									>
								</div>
							</div>
						</div>
					</div>
					<div
						class="mt-6"
						v-for="award in staffData?.public_information
							?.certificates_and_awards?.awards"
						:key="award"
					>
						<div class="text-neutral-600 font-semibold text-lg">
							{{ award.award_name }}
						</div>
						<div class="text-neutral-500 text-sm mt-1">
							{{ award.award_description }}
						</div>
						<div v-if="award?.award_file_url">
							<div
								v-if="award?.type !== 'application/pdf'"
								class="rounded-lg relative mt-2"
							>
								<img
									:src="award?.award_file_url"
									alt=""
									class="rounded-lg object-fill h-full w-full"
								/>
							</div>
							<div
								v-if="award?.type === 'application/pdf'"
								class="rounded-lg relative mt-2"
							>
								<div
									class="text-neutral-400 flex items-center gap-2"
								>
									<svg
										width="24"
										height="32"
										viewBox="0 0 24 32"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M0 4C0 1.79086 1.79086 0 4 0H14.5858C15.1162 0 15.6249 0.210714 16 0.585786L23.4142 8C23.7893 8.37507 24 8.88378 24 9.41421V28C24 30.2091 22.2091 32 20 32H4C1.79086 32 0 30.2091 0 28V4ZM15 7V3L21 9H17C15.8954 9 15 8.10457 15 7ZM17.7071 15.7071C18.0976 15.3166 18.0976 14.6834 17.7071 14.2929C17.3166 13.9024 16.6834 13.9024 16.2929 14.2929L11 19.5858L8.70711 17.2929C8.31658 16.9024 7.68342 16.9024 7.29289 17.2929C6.90237 17.6834 6.90237 18.3166 7.29289 18.7071L10.2929 21.7071C10.4804 21.8946 10.7348 22 11 22C11.2652 22 11.5196 21.8946 11.7071 21.7071L17.7071 15.7071Z"
											fill="#E5A42B"
										/>
									</svg>
									<a
										:href="award?.award_file_url"
										target="_blank"
										class="text-neutral-600 font-semibold cursor-pointer hover:underline"
									>
										{{ award.file_name }}</a
									>
								</div>
							</div>
						</div>
					</div>
					<div
						v-if="
							staffData?.public_information?.professional_qualifications?.language_skills?.filter(
								(ls) => ls && ls.length > 0
							)?.length > 0
						"
					>
						<div class="mt-6">
							<div
								class="text-neutral-600 font-semibold text-3xl"
							>
								Ngoại ngữ
							</div>
							<div
								class="text-neutral-800 mt-1 pl-4"
								v-for="ls in staffData?.public_information
									?.professional_qualifications
									?.language_skills"
								:key="ls"
							>
								<li>{{ ls }}</li>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
